export const RULE_SCHEMA_VERSION = 1;

export const RULE_CATEGORIES = Object.freeze({
  PERFORMANCE: 'performance',
  COMPLIANCE: 'compliance',
});

export const RULE_STATUS = Object.freeze({
  SUGGESTED: 'suggested',
  ACTIVE: 'active',
  DISABLED: 'disabled',
});

export const RULE_SOURCE = Object.freeze({
  BUILT_IN: 'built_in',
  AI_SUGGESTED: 'ai_suggested',
  USER_CREATED: 'user_created',
  DISCOVERY_RULE: 'discovery_rule',
});

export const RULE_TYPES = Object.freeze({
  METRIC_THRESHOLD: 'metric_threshold',
  METRIC_RATIO_THRESHOLD: 'metric_ratio_threshold',
  ATTRIBUTE_COMPLETENESS: 'attribute_completeness',
  REQUIRED_ACTIVITY: 'required_activity',
  REQUIRED_SEQUENCE: 'required_sequence',
  FORBIDDEN_TRANSITION: 'forbidden_transition',
});

export function normalizeRule(rule = {}) {
  return {
    id: String(rule.id || ''),
    name: String(rule.name || 'Untitled rule'),
    description: String(rule.description || ''),
    category: rule.category === RULE_CATEGORIES.COMPLIANCE ? RULE_CATEGORIES.COMPLIANCE : RULE_CATEGORIES.PERFORMANCE,
    ruleType: Object.values(RULE_TYPES).includes(rule.ruleType) ? rule.ruleType : RULE_TYPES.METRIC_THRESHOLD,
    status: Object.values(RULE_STATUS).includes(rule.status) ? rule.status : RULE_STATUS.ACTIVE,
    source: Object.values(RULE_SOURCE).includes(rule.source) ? rule.source : RULE_SOURCE.USER_CREATED,
    severity: ['low', 'medium', 'high', 'critical'].includes(String(rule.severity || '').toLowerCase()) ? String(rule.severity).toLowerCase() : 'medium',
    metric: rule.metric || null,
    numeratorMetric: rule.numeratorMetric || null,
    denominatorMetric: rule.denominatorMetric || null,
    attribute: rule.attribute || null,
    activity: rule.activity || null,
    fromActivity: rule.fromActivity || null,
    toActivity: rule.toActivity || null,
    operator: ['>', '>=', '<', '<=', '==', '!='].includes(rule.operator) ? rule.operator : '>',
    threshold: Number.isFinite(Number(rule.threshold)) ? Number(rule.threshold) : 0,
    unit: rule.unit || null,
    rationale: String(rule.rationale || ''),
    evidenceBasis: String(rule.evidenceBasis || ''),
    aiProvider: rule.aiProvider || null,
    aiModel: rule.aiModel || null,
    suggestedAt: rule.suggestedAt || null,
    baseRuleId: rule.baseRuleId || null,
    isOverride: Boolean(rule.isOverride),
    createdAt: rule.createdAt || null,
    updatedAt: rule.updatedAt || null,
    sourceDiscoveryRuleId: rule.sourceDiscoveryRuleId || null,
    sourceDiscoveryRuleName: rule.sourceDiscoveryRuleName || null,
  };
}

export function normalizeRuleBundle(bundle) {
  const input = bundle && typeof bundle === 'object' && !Array.isArray(bundle) ? bundle : {};
  const definitions = Array.isArray(input.definitions) ? input.definitions.map(normalizeRule).filter(r => r.id) : [];
  return {
    version: Number(input.version || RULE_SCHEMA_VERSION),
    definitions,
    results: Array.isArray(input.results) ? input.results : [],
    evaluatedAt: input.evaluatedAt || null,
  };
}
